import { OrganizationServiceType } from "@/domain/Optimize";

const HELP_URL_PLANIUM =
  "https://algo-artis.notion.site/Planium-28a9ccb5a97c4915a1752ae59aa78b85";
const HELP_URL_DEFAULT =
  "https://algo-artis.notion.site/ALGO-ARTIS-136af951024b8039b020f804251dfc01";

export const openHelpPage = (
  orgServiceType: OrganizationServiceType | null
) => {
  window.open(
    orgServiceType === "planium" ? HELP_URL_PLANIUM : HELP_URL_DEFAULT,
    "_blank",
    "noopener,noreferrer"
  );
};
